import React, { createContext } from 'react'

export interface IExternalComponentsProvider {
  components?: { [name: string]: React.FC<any> | undefined }
}
const ExternalComponentContext = createContext<IExternalComponentsProvider>({})

export const ExternalComponentProvider: React.FC<IExternalComponentsProvider> = ({
  components,
  children
}) => {
  return (
    <ExternalComponentContext.Provider value={{ components }}>
      <div>{children}</div>
    </ExternalComponentContext.Provider>
  )
}

const Fallback = (props: any) => props.children

interface IUseExternalComponentContext {
  component: string
  props: { [key: string]: any }
  children?: React.ReactNode
}

export const UseExternalComponentContext = ({ component, props }: IUseExternalComponentContext) => {
  try {
    const { components = {} } = React.useContext(ExternalComponentContext)
    const ComponentBase = components[component]
    if (ComponentBase) return <ComponentBase {...props} />
    if (Fallback) return <Fallback>{props.children || null}</Fallback>
    return <div>Error</div>
  } catch (error) {
    console.log(error)
    if (Fallback) return <Fallback>{props.children || null}</Fallback>
    return <div>Error</div>
  }
}
